import { Container, Grid } from "@mui/material";
import { SideBar } from "./sideBar";
import TopBar from "./topBar";
import { Outlet, useNavigate } from "react-router-dom";
import useIdle from "../../hooks/useIdleTimer";
import ModalLogOut from "../common/Modals/modalLogOut";
import { useEffect, useState } from "react";
import { LogoutService, SupportLogoutService } from "../../services/auth/authServices";
import { CODES } from "../../consts/codes";
import { resetCurrentCompany } from "../../parts/listUsers/listUsersSlice";
import { useDispatch, useSelector } from "react-redux";
import { getUser } from "../../pages/userSlice";

const Layout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [openInactivity, setOpenInactivity] = useState(false);
  const [showMenu, setShowMenu] = useState(window.innerWidth > 768);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);

  const openMenuLevelOne = useSelector((state) => state.user.user?.openMenuLevelOne);
  const userInfo = useSelector(getUser);

  /** Efecto para gestionar el conteo de pestañas activas y cerrar sesión al cerrar la última. */
  useEffect(() => {
    const updateTabCount = (change) => {
      const currentCount = parseInt(localStorage.getItem("activeTabs")) || 0;
      const newCount = Math.max(0, currentCount + change);
      localStorage.setItem("activeTabs", newCount);
      return newCount;
    };

    const handleTabOpen = () => {
      updateTabCount(1);
    };

    const handleTabClose = (event) => {
      const navigationType = performance.getEntriesByType("navigation")[0]?.type;

      const newCount = updateTabCount(-1);
      if (newCount === 0) {
        if (
          event.type === "beforeunload" &&
          (navigationType === "reload" || navigationType === "navigate")
        ) {
          return;
        } else {
          handleLogOut();
        }
      }
    };

    window.addEventListener("load", handleTabOpen);
    window.addEventListener("beforeunload", handleTabClose);

    return () => {
      window.removeEventListener("load", handleTabOpen);
      window.removeEventListener("beforeunload", handleTabClose);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /** Cierra la sesión del usuario y redirige al login. */
  const handleLogOut = async () => {
    try {
      if (userInfo?.support === "Y") {
        await SupportLogoutService({
          eanCompany: userInfo.eanCompanyMain,
          nameCompany: userInfo.eanCompanyMain,
          country: userInfo.country,
          email: userInfo.email,
        });
      }

      const {
        status,
        data: { responseCode },
      } = await LogoutService();

      if (
        status === CODES.COD_RESPONSE_HTTP_OK &&
        (responseCode === CODES.COD_RESPONSE_SUCCESS_REQUEST ||
          responseCode === CODES.COD_RESPONSE_HTTP_BAD_REQUEST)
      ) {
        localStorage.clear();
        sessionStorage.clear();
        dispatch(resetCurrentCompany());
        navigate("/");
      }
    } catch (error) {
      //TODO: Falta implementar inserción de log en dynamodb
    }
  };

  /** Abre el modal de advertencia por inactividad. */
  const openInactivityWarning = () => {
    setOpenInactivity(true);
  };

  const { reset: resetTimerInactivity } = useIdle({
    onIdle: handleLogOut,
    idleTime: 10,
    promptTime: 1,
    onPrompt: openInactivityWarning,
  });

  /** Actualiza el estado de visibilidad del menú según el tamaño de ventana. */
  const updateMedia = () => {
    setShowMenu(window.innerWidth > 768);
    setIsDesktop(window.innerWidth > 768);
  };

  /** Efecto para escuchar cambios de tamaño de ventana. */
  useEffect(() => {
    window.addEventListener("resize", updateMedia);
    return () => window.removeEventListener("resize", updateMedia);
  });

  /** Efecto para mostrar el menú cuando openMenuLevelOne cambia en dispositivos no desktop. */
  useEffect(() => {
    if (openMenuLevelOne !== false && openMenuLevelOne !== undefined && !isDesktop) {
      setShowMenu(true);
    }
  }, [openMenuLevelOne, isDesktop]);

  return (
    <Grid className="container__page">
      <Grid container>
        {showMenu && (
          <Grid item xl={0.6} lg={0.87} md={1.28} sm={1.4} xs={2}>
            <SideBar setShowMenu={setShowMenu} />
          </Grid>
        )}
        <Grid
          item
          xl={!showMenu ? 12 : 11.4}
          lg={!showMenu ? 12 : 11.13}
          md={!showMenu ? 12 : 11.72}
          sm={!showMenu ? 12 : 10.6}
          xs={!showMenu ? 12 : 10}
        >
          <TopBar setShowMenu={setShowMenu} showMenu={showMenu} />
        </Grid>
      </Grid>

      <Grid container>
        {showMenu && <Grid item xl={0.6} lg={0.87} md={1.28} sm={1.4} xs={2}></Grid>}
        <Grid
          item
          xl={!showMenu ? 12 : 11.4}
          lg={!showMenu ? 12 : 11.13}
          md={!showMenu ? 12 : 11.72}
          sm={!showMenu ? 12 : 10.6}
          xs={!showMenu ? 12 : 10}
          style={{ paddingRight: "2rem", paddingTop: "2rem" }}
        >
          <Container style={{ paddingLeft: "4rem" }} className="main_content_container">
            <ModalLogOut
              isOpen={openInactivity}
              setIsOpen={setOpenInactivity}
              resetTimerInactivity={resetTimerInactivity}
            />

            <Outlet />
          </Container>
        </Grid>
      </Grid>
    </Grid>
  );
};

/** Componente Layout para el layout principal de la aplicación. */
export default Layout;